module.exports = __webpack_public_path__ + "img/texture3.bb5ac826.jpg";